import axios from 'axios';
import {
  APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_BEGIN,
  APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_SUCCESS,
  APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_FAILURE,
  APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function loadProjectDetailAppSetting(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_BEGIN,
    });

    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/`,
        args.data,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadProjectDetailAppSettingError() {
  return {
    type: APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_BEGIN:
      return {
        ...state,
        loadProjectDetailAppSettingPending: true,
        loadProjectDetailAppSettingError: null,
      };

    case APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_SUCCESS:
      return {
        ...state,
        loadProjectDetailAppSettingPending: false,
        loadProjectDetailAppSettingError: null,
        projectDetail: action.data,
      };

    case APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_FAILURE:
      return {
        ...state,
        loadProjectDetailAppSettingPending: false,
        loadProjectDetailAppSettingError: action.data.error,
      };

    case APP_SETTING_LOAD_PROJECT_DETAIL_APP_SETTING_DISMISS_ERROR:
      return {
        ...state,
        loadProjectDetailAppSettingError: null,
      };

    default:
      return state;
  }
}
